import { createSlice } from '@reduxjs/toolkit';

export const forgotUsername = createSlice({
    name: 'forgotUsername',

    initialState: {
        forgotUsernameModal: false
    },

    reducers: {
        setForgotUsernameModal: (state, action) => {
            state.forgotUsernameModal = action.payload;
        }
    }
});

export const { setForgotUsernameModal } = forgotUsername.actions;

export default forgotUsername.reducer;
